import React from 'react';
import cx from 'classnames';
import Button from '@mui/material/Button';
import styles from '@/common/containers/Modals/UserGuide/styles.less';
import { Trans, useTranslation } from 'react-i18next';

const WellDone = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.modalHeader}>
        <h3>{t('Well done!')}</h3>
      </div>
      <div className={cx(styles.modalBody, styles.overview)}>
        <p className={styles.overviewText}>
          <Trans
            i18nKey="You have completed the <1>Immediate tasks questionnaire</1> and can now proceed with the <2>Immediate tasks</2> list."
            components={{ 1: <b />, 2: <b /> }}
          />
        </p>
        <p className={styles.overviewText}>
          {t('You now have access to all task modules.')}
        </p>
        <p className={styles.overviewText}>
          <Trans
            i18nKey="We recommend completing the modules in the predefined order. However, the <1>Main tasks</1> and <2>Assets tasks</2> modules could be performed concurrently after the <3>Legal tasks</3>."
            components={{ 1: <b />, 2: <b />, 3: <b /> }}
          />
        </p>
        <p className={styles.overviewText}>
          <Trans
            i18nKey="<1>Closing tasks</1> should only be started after all other modules are completed."
            components={{ 1: <b /> }}
          />
        </p>
      </div>
      <div className={styles.modalFooter}>
        <div className={styles.modalFooterBtns}>
          <Button variant="contained" type="success" onClick={onClose}>
            {t('Ok')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default WellDone;
